// extracted by mini-css-extract-plugin
module.exports = {"inherit":"getFontFamily_inherit__3CiVR","primary":"getFontFamily_primary__3Dr4G","secondary":"getFontFamily_secondary__xOC5n","system":"getFontFamily_system__2KYCL"};